import React from 'react';
import { Link } from 'react-router-dom';
import { IconPin, IconPhone, IconMail } from './Icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* О компании */}
        <div className="footer-section">
          <h4>О компании</h4>
          <p>
            Автостекло-Сервис в Бийске — ваш надежный партнер по продаже, установке и ремонту автомобильных стекол.
          </p>
        </div>

        {/* Навигация */}
        <div className="footer-section">
          <h4>Навигация</h4>
          <ul>
            <li><Link to="/">Главная</Link></li>
            <li><Link to="/contacts">Контакты</Link></li>
          </ul>
        </div>

        {/* Контакты со строгими иконками */}
        <div className="footer-section">
          <h4>Контакты</h4>
          <ul className="footer-contacts-list">
            <li className="footer-contact-row">
              <IconPin size={18} color="#dcbc1a" />
              <span>г. Бийск, ул. Революции, 55а</span>
            </li>
            <li className="footer-contact-row">
              <IconPhone size={18} color="#dcbc1a" />
              <a href="tel:+79609474777">+7 (960) 947-47-77</a>
            </li>
            <li className="footer-contact-row">
              <IconMail size={18} color="#dcbc1a" />
              <a href="mailto:ag1309@mail.ru">ag1309@mail.ru</a>
            </li>
          </ul>
        </div>

      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} Автостекло-Сервис. Все права защищены.
      </div>
    </footer>
  );
};

export default Footer;